import React, { useState } from 'react';
import { Link, Routes, Route, useNavigate } from 'react-router-dom';
import { trackEvent } from '../utils/matomoEvents';
import { photoPosition } from '../utils/photoPosition';
import { dogProfiles } from '../data/dogProfiles';
import DogProfilePage from './dogs/DogProfilePage';

export default function OurGators() {
  // Filter dogs by role (mothers and studs) and visibility
  const mothers = Object.values(dogProfiles)
    .filter(dog => ['pearl', 'zannah', 'tonks', 'gidget'].includes(dog.id) && dog.visible)
    .map(dog => ({
      id: dog.id,
      name: dog.name,
      image: dog.image,
      bio: dog.short_bio,
      ourGators_backgroundPosition: dog.ourGators_backgroundPosition,
      ourGators_mobile_backgroundPosition: dog.ourGators_mobile_backgroundPosition
    }));

  const studs = Object.values(dogProfiles)
    .filter(dog => ['dume', 'hotsauce', 'revan'].includes(dog.id) && dog.visible)
    .map(dog => ({
      id: dog.id,
      name: dog.name,
      image: dog.image,
      bio: dog.short_bio,
      ourGators_backgroundPosition: dog.ourGators_backgroundPosition,
      ourGators_mobile_backgroundPosition: dog.ourGators_mobile_backgroundPosition
    }));

  return (
    <div className="our-gators">
      <Routes>
        {Object.values(dogProfiles).map(dog => (
          <Route
            key={dog.id}
            path={`/${dog.id}`}
            element={<DogProfilePage dogId={dog.id} />}
          />
        ))}
        <Route path="/" element={
          <div className="dog-overview">
            <section className="mothers-section">
              <h2>Our Females</h2>
              <div className="dog-grid">
                {mothers.map(dog => (
                  <Link
                    to={`/our-gators/${dog.id}`}
                    key={dog.id}
                    className="dog-card"
                    onClick={() => trackEvent('Navigation', 'DogProfileView', `Female - ${dog.name}`)}
                  >
                    <div className="dog-image" style={{
                      backgroundImage: `url(${dog.image})`,
                      height: '250px',
                      backgroundSize: 'cover',
                      borderRadius: '8px',
                      ...photoPosition(
                        dog.ourGators_backgroundPosition,
                        dog.ourGators_mobile_backgroundPosition
                      )
                    }}></div>
                    <h3>{dog.name}</h3>
                    <p>{dog.bio}</p>
                  </Link>
                ))}
              </div>
            </section>

            <section className="studs-section">
              <h2>Our Studs</h2>
              <div className="dog-grid">
                {studs.map(dog => (
                  <Link
                    to={`/our-gators/${dog.id}`}
                    key={dog.id}
                    className="dog-card"
                    onClick={() => trackEvent('Navigation', 'DogProfileView', `Stud - ${dog.name}`)}
                  >
                    <div className="dog-image" style={{
                      backgroundImage: `url(${dog.image})`,
                      height: '250px',
                      backgroundSize: 'cover',
                      borderRadius: '8px',
                      ...photoPosition(
                        dog.ourGators_backgroundPosition,
                        dog.ourGators_mobile_backgroundPosition
                      )
                    }}></div>
                    <h3>{dog.name}</h3>
                    <p>{dog.bio}</p>
                  </Link>
                ))}
              </div>
            </section>
          </div>
        } />
      </Routes>

      <style jsx>{`
        .our-gators {
          padding: 2rem;
        }
        .dog-nav {
          display: flex;
          justify-content: center;
          gap: 4rem;
          margin-bottom: 2rem;
          position: relative;
        }
        .nav-item {
          position: relative;
          cursor: pointer;
        }
        .nav-item h2 {
          margin: 0;
          color: var(--text);
          font-size: 1.5rem;
        }
        .mothers-section, .studs-section {
          margin-bottom: 3rem;
        }
        .dog-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          margin-top: 1rem;
        }
        .dog-card {
          background: var(--surface);
          border-radius: 8px;
          padding: 1rem;
          box-shadow: 0 2px 4px var(--shadow);
          text-decoration: none;
          transition: transform 0.2s;
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .dog-card h3 {
          margin: 1rem 0 0.5rem;
          color: var(--text);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .dog-card p {
          color: var(--text-faint);
          line-height: 1.6;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          margin: 0;
        }
        .dog-card:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 8px var(--shadow-strong);
        }
        .dog-image {
          background-position: var(--photo-pos, center);
        }
        @media (max-width: 768px) {
          .dog-image {
            /* ourGators_mobile_backgroundPosition, when a dog has one. */
            background-position: var(--photo-pos-mobile, var(--photo-pos, center));
          }
        }
      `}</style>
    </div>
  );
}